import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "holiday-work-pattern-setting-container grid justify-center mt-5 mb-32" }
const _hoisted_2 = { class: "w-240" }
const _hoisted_3 = { class: "title text-3xl font font-normal" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3 mt-3" }, null, -1)
const _hoisted_5 = { class: "flex items-center mt-4" }
const _hoisted_6 = { class: "w-94" }
const _hoisted_7 = { class: "flex items-center mt-4" }
const _hoisted_8 = { class: "w-94" }
const _hoisted_9 = { class: "flex items-center mt-4" }
const _hoisted_10 = { class: "select" }
const _hoisted_11 = { class: "w-94" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-plus text-xl mr-4" }, null, -1)
const _hoisted_13 = { class: "font-bold mt-10 font-size-18" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "divide-blue mb-3 mt-3" }, null, -1)
const _hoisted_15 = { class: "flex items-center mt-4" }
const _hoisted_16 = { class: "flex justify-start font-size-16 font-bold w-86" }
const _hoisted_17 = { class: "flex justify-start font-size-16 font-bold" }
const _hoisted_18 = { class: "flex justify-start" }
const _hoisted_19 = { class: "select w-48" }
const _hoisted_20 = { class: "flex justify-start ml-4" }
const _hoisted_21 = { class: "select w-48" }
const _hoisted_22 = { class: "ml-4 flex mt-3" }
const _hoisted_23 = { class: "action flex mt-2" }
const _hoisted_24 = { class: "tooltiptext" }
const _hoisted_25 = { class: "tooltiptext" }
const _hoisted_26 = { class: "action flex justify-center mr-20" }
const _hoisted_27 = { class: "action flex justify-center mr-20" }
const _hoisted_28 = { class: "popup-title flex justify-center mt-6 w-180" }
const _hoisted_29 = { class: "font-bold font-size-36" }
const _hoisted_30 = { class: "flex justify-center mt-6" }
const _hoisted_31 = { class: "flex justify-center mt-12 mb-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")
  const _component_Select = _resolveComponent("Select")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Table = _resolveComponent("Table")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('workPatternSetting')), 1),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_Label, {
              mandatory: "",
              "text-label": _ctx.t('workPatternCode')
            }, null, 8, ["text-label"]),
            _createVNode(_component_Input, {
              modelValue: _ctx.apiPostData.shift_pattern_code,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiPostData.shift_pattern_code = $event)),
              validated: _ctx.validated,
              required: "",
              errors: _ctx.errors.shift_pattern_code,
              "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.shift_pattern_code = $event)),
              "error-server": _ctx.errorsServer.shift_pattern_code
            }, null, 8, ["modelValue", "validated", "errors", "error-server"])
          ])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_Label, {
              mandatory: "",
              "text-label": _ctx.t('workPatternName')
            }, null, 8, ["text-label"]),
            _createVNode(_component_Input, {
              modelValue: _ctx.apiPostData.shift_pattern_name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiPostData.shift_pattern_name = $event)),
              validated: _ctx.validated,
              required: "",
              errors: _ctx.errors.shift_pattern_name,
              "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.shift_pattern_name = $event)),
              "error-server": _ctx.errorsServer.shift_pattern_name
            }, null, 8, ["modelValue", "validated", "errors", "error-server"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_Label, {
                "text-label": _ctx.t('ApplicableOra')
              }, null, 8, ["text-label"]),
              _createVNode(_component_Input, {
                readonly: "",
                modelValue: _ctx.organizationText,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.organizationText = $event)),
                placeholder: _ctx.t('pleaseSetWithTheButtonOnTheRight'),
                "error-server": _ctx.errorsServer.unit_ids
              }, null, 8, ["modelValue", "placeholder", "error-server"])
            ])
          ]),
          _createVNode(_component_Button, {
            onClick: _ctx.showPopupSelect,
            class: "btn-outline-blue w-58 h-12 ml-16 mt-8"
          }, {
            default: _withCtx(() => [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.t('selectAppOrangBtn')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode("div", _hoisted_13, _toDisplayString(_ctx.t('workHoursAndBreaks')), 1),
        _hoisted_14,
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.t('timeZoneStart')), 1),
          _createVNode("div", _hoisted_17, _toDisplayString(_ctx.t('timeZoneEnd')), 1)
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.apiPostData.shift_pattern_times, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: item,
            class: "flex mt-4"
          }, [
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_Select, {
                  placeholder: _ctx.t('placeholderSelect'),
                  "options-select": _ctx.optionsChoseTime,
                  "item-text": "text",
                  modelValue: 
                _ctx.apiPostData.shift_pattern_times[index].start_time_day_type
              ,
                  "onUpdate:modelValue": ($event: any) => (
                _ctx.apiPostData.shift_pattern_times[index].start_time_day_type
               = $event),
                  validated: _ctx.validated,
                  required: _ctx.apiPostData.shift_pattern_times[index].start_time,
                  errors: 
                _ctx.errors['shift_pattern_times' + index + 'start_time_day_type']
              ,
                  "onUpdate:errors": ($event: any) => (
                _ctx.errors['shift_pattern_times' + index + 'start_time_day_type']
               = $event)
                }, null, 8, ["placeholder", "options-select", "modelValue", "onUpdate:modelValue", "validated", "required", "errors", "onUpdate:errors"])
              ]),
              _createVNode(_component_InputTime, {
                class: "w-32 ml-2",
                modelValue: _ctx.apiPostData.shift_pattern_times[index].start_time,
                "onUpdate:modelValue": ($event: any) => (_ctx.apiPostData.shift_pattern_times[index].start_time = $event),
                errors: 
              _ctx.errors['shift_pattern_times' + index + 'start_time']
            ,
                "onUpdate:errors": ($event: any) => (
              _ctx.errors['shift_pattern_times' + index + 'start_time']
             = $event),
                validated: _ctx.validated,
                required: 
              _ctx.apiPostData.shift_pattern_times[index].start_time_day_type ===
                0 || _ctx.apiPostData.shift_pattern_times[index].start_time_day_type
            ,
                "error-server": 
              _ctx.errorsServer[`shift_pattern_times.${index}.start_time`]
            
              }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required", "error-server"])
            ]),
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode(_component_Select, {
                  placeholder: _ctx.t('placeholderSelect'),
                  "options-select": _ctx.optionsChoseTime,
                  "item-text": "text",
                  modelValue: _ctx.apiPostData.shift_pattern_times[index].end_time_day_type,
                  "onUpdate:modelValue": ($event: any) => (_ctx.apiPostData.shift_pattern_times[index].end_time_day_type = $event),
                  errors: 
                _ctx.errors['shift_pattern_times' + index + 'end_time_day_type']
              ,
                  "onUpdate:errors": ($event: any) => (
                _ctx.errors['shift_pattern_times' + index + 'end_time_day_type']
               = $event),
                  validated: _ctx.validated,
                  required: _ctx.apiPostData.shift_pattern_times[index].end_time
                }, null, 8, ["placeholder", "options-select", "modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required"])
              ]),
              _createVNode(_component_InputTime, {
                class: "w-32 ml-2",
                modelValue: _ctx.apiPostData.shift_pattern_times[index].end_time,
                "onUpdate:modelValue": ($event: any) => (_ctx.apiPostData.shift_pattern_times[index].end_time = $event),
                errors: _ctx.errors['shift_pattern_times' + index + 'end_time'],
                "onUpdate:errors": ($event: any) => (_ctx.errors['shift_pattern_times' + index + 'end_time'] = $event),
                validated: _ctx.validated,
                required: 
              _ctx.apiPostData.shift_pattern_times[index].end_time_day_type === 0 ||
              _ctx.apiPostData.shift_pattern_times[index].end_time_day_type
            ,
                "error-server": 
              _ctx.errorsServer[`shift_pattern_times.${index}.end_time`]
            
              }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "onUpdate:errors", "validated", "required", "error-server"])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode(_component_Checkbox, {
                class: "mr-5",
                "option-checkbox": { label: '休憩' },
                modelValue: _ctx.apiPostData.shift_pattern_times[index].is_break,
                "onUpdate:modelValue": ($event: any) => (_ctx.apiPostData.shift_pattern_times[index].is_break = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createVNode("div", _hoisted_23, [
              (_ctx.apiPostData.shift_pattern_times.length > 1)
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    onClick: ($event: any) => (_ctx.removeTimezoneDetail(index)),
                    class: "cp-icon-minus-circle cursor-pointer text-3xl text-red-ff"
                  }, [
                    _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t('actionDelete')), 1)
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true),
              (index === _ctx.apiPostData.shift_pattern_times.length - 1)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: [
              _ctx.isDisableAdd(item) ? 'pointer-events-none text-grey-999' : ''
            , "cp-icon-plus-circle cursor-pointer text-3xl ml-4 text-light-blue"],
                    onClick: ($event: any) => (_ctx.addTimezoneDetail(item))
                  }, [
                    _createVNode("span", _hoisted_25, _toDisplayString(_ctx.t('addAction')), 1)
                  ], 10, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128)),
        _createVNode("div", _hoisted_26, [
          _createVNode(_component_Button, {
            onClick: _ctx.handleRegisterOrUpdate,
            class: "w-50 h-12 mt-12 btn-gradation-light-blue"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('toRegister')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode(_component_Button, {
            onClick: _ctx.handleCancel,
            class: "btn-none-border w-50 h-12 mt-3"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _createVNode(_component_Popup, {
      modelValue: _ctx.isShow,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShow = $event)),
      classes: "size-xs-popup",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_28, [
          _createVNode("p", _hoisted_29, _toDisplayString(_ctx.t('selectAppOrang')), 1)
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode(_component_Table, {
            class: "w-120 max-h-132",
            fixedHeader: "",
            data: _ctx.unitList,
            showSelect: "",
            headers: _ctx.headerDatas,
            "selected-item": _ctx.organizationSelected,
            "onUpdate:selected-item": _cache[6] || (_cache[6] = ($event: any) => (_ctx.organizationSelected = $event))
          }, {
            unit_name: _withCtx(({ item }) => [
              _createVNode("div", {
                class: "flex justify-center py-2 cursor-pointer",
                onClick: ($event: any) => (_ctx.onClickName(item))
              }, [
                _createVNode("div", null, _toDisplayString(item.unit_name), 1)
              ], 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["data", "headers", "selected-item"])
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode(_component_Button, {
            onClick: _ctx.saveSelectedOrganization,
            class: "btn-gradation-light-blue w-50 h-12 mr-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('select')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_Button, {
            onClick: _ctx.hiddenPopupSelect,
            class: "btn-gradation-secondary w-50 h-12"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}